var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLog1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 804,
    height: 623,
    viewBox: "0 0 804 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1216_949)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M4.11591e-06 259.782L804 252.18L508.681 603.734C507.326 606.285 505.294 608.285 502.875 609.45C495.809 613.158 488.34 615.791 480.663 617.281C468.931 619.898 457.072 621.731 445.149 622.769C431.393 624.084 416.148 624.827 400.094 624.827C384.041 624.827 368.77 624.084 355.039 622.769C343.078 621.66 331.186 619.751 319.424 617.053C311.748 615.559 304.28 612.926 297.212 609.222C294.793 608.057 292.761 606.056 291.407 603.505L4.11591e-06 259.782Z",
    fill: "url(#paint0_linear_1216_949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M207.962 54.1657H594.148L473.446 603.162C472.692 605.508 471.339 607.547 469.559 609.021C465.007 612.71 459.901 615.431 454.49 617.053C446.697 619.723 438.718 621.635 430.638 622.769C410.579 625.551 390.295 625.551 370.236 622.769C362.148 621.635 354.16 619.723 346.358 617.053C341.011 615.43 335.966 612.729 331.466 609.078C329.679 607.613 328.324 605.571 327.579 603.219L207.962 54.1657Z",
    fill: "url(#paint1_linear_1216_949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1216_949",
    x1: 401.987,
    y1: 689.736,
    x2: 401.987,
    y2: 309.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1216_949",
    x1: 401.005,
    y1: 802.319,
    x2: 401.005,
    y2: 255.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1216_949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 804,
    height: 623,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog1);
export default __webpack_public_path__ + "static/media/log1.58b7a3f59428c19d6407dcd7295d8e2b.svg";
export { ForwardRef as ReactComponent };